import { createState, Downgraded, State, useState } from '@hookstate/core';
import { IModalState } from '../interfaces/app.interface';

const initState: IModalState = {
  pathto: '',
  showLogin: false,
  showSignUp: false,
  showSignUpByEmail: false,
  showForgot: false,
};

const modalState = createState(initState);

const wrapState = (s: State<IModalState>) => {
  return {
    /**
     * Get state
     * @returns
     */
    get: () => s.value,

    /**
     * Set state
     * @param state
     * @returns
     */
    set: (state: IModalState) => s.set({ ...s.value, ...state }),

    /**
     * Set a state field
     * @param key
     * @param value
     * @returns
     */
    setValue: (key: keyof IModalState, value: any) =>
      s.set({ ...s.value, [key]: value }),

    showModal: (key: keyof IModalState, pathto: string = '') => {
      return s.set({ ...initState, [key]: true, pathto });
    },
  };
};

// It can be used inside of a component
export const useModalState = () =>
  wrapState(useState(modalState).attach(Downgraded));
export const accessModalState = () => wrapState(modalState);
